import { Box, Stack } from '@mui/material';
import { Children, PropsWithChildren } from 'react';

export default function Footer(props: PropsWithChildren) {
    return (
        <Stack justifyContent="center" textAlign="center" typography="body2" color="grey.700">
            {Children.map(props.children, child => (
                <Box>{child}</Box>
            ))}
        </Stack>
    );
}
